import React, { FunctionComponent } from 'react';

import getClassName from 'src/common/utils/getClassName';
import Button from '../Button';
import s from './FormButtons.module.scss';

type BareFormButtonsProps = {
  closeModal: () => void;
  submitting?: boolean;
  classNameModifier?: string;
  onSubmit?: () => void;
  submitText?: string;
  cancelText?: string;
  disabled?: boolean;
};

export const BareFormButtons: FunctionComponent<BareFormButtonsProps> = ({
  closeModal,
  submitting,
  children,
  classNameModifier,
  onSubmit,
  submitText = 'Done',
  cancelText = 'Cancel',
  disabled = false,
}) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    {children}
    <Button
      type="reset"
      onClick={closeModal}
      classNameModifier={`${classNameModifier} secondary`}
      fullWidth
    >
      {cancelText}
    </Button>
    <Button
      type={onSubmit ? 'button' : 'submit'}
      onClick={onSubmit}
      submitting={submitting}
      classNameModifier={classNameModifier}
      disabled={disabled}
      fullWidth
    >
      {submitText}
    </Button>
  </div>
);

export default BareFormButtons;
